import { render, staticRenderFns } from "./OrderableTable.vue?vue&type=template&id=5e5eb03c&lang=pug&"
import script from "./OrderableTable.vue?vue&type=script&lang=js&"
export * from "./OrderableTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports